var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.symbol.type === "Vertical Divider Line"
    ? _c("div", { class: _vm.symbolClasses })
    : _c("hr", {
        class: _vm.symbolClasses,
        domProps: { innerHTML: _vm._s(_vm.symbol.content) },
      })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }